<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>


    <!--====== OFFCANVAS MENU PART START ======-->
    <!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu"  @toggleSidebar="toggleSidebar"  :menuItems="navs" />-->
    <!--====== OFFCANVAS MENU PART ENDS ======-->

    <!--====== APPIE HEADER PART START ======-->
<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->


    <section class="appie-testimonial-2-area" id="testimonial">
<!--      <div class="container maincard" v-if="!showloading">-->
      <div class="container " v-if="!showloading">
        <div class="row">
          <div class="col-md-3 whitebackground menudiv">
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >
            <div class="col-lg-12 mt-2">
            <div>

              <Commonprofile/>
            </div>

            <div class="row mt-4">
              <div v-for="(item, itemIndex) in mergedTemplates" :key="itemIndex"  class="col-md-4 mb-2">



                <div  style="cursor: pointer">
                  <!--                          <div class="   align-items-center">-->
                  <div  v-if="item.view_type=='template_5'">
                    <div  id="features">
                      <a @click="commonview(item.activity,item.url)" style="display: block;">
                        <div style="cursor: pointer">
                          <div class="appie-features-box-item item-2  appie-features-box-5-item homelist"   >
                            <img :src="item.icon" alt="" class="imageSize">
                            <span :style="{ color: item.txt_color,marginLeft:'20px' }">{{ item.name }}</span>
                            <span class="badge"
                                  :style="{ color: item.btntextColor,float:'right',border:item.borderColor,backgroundColor:item.btnColor }"
                                  v-html="item.btnText"></span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div  v-if="item.view_type=='template_9'">

                    <div id="features card">


                      <a @click="commonview(item.activity,item.url,item.type,item.action)" style="display: block;">
                        <div class="appie-features-box-item item-2  appie-features-box-5-item homelist">
                          <img :src="item.image" alt="" class="imageSize">

                          <span :style="{ color: item.txt_color,marginLeft:'20px' }">{{ item.title }}</span>

                          <span class="badge"
                                :style="{ color: item.btntextColor,float:'right',border:item.borderColor,backgroundColor:item.btnColor }"
                                v-html="item.btnText"></span>

                        </div>
                      </a>
                    </div>

                  </div>


                </div>
                <!--                          </div>-->

              </div>
            </div>

              <div class="row">
                <div v-if="insideloader" style="margin-top: -90px">
                  <loader-appie/>
                </div>
                <div v-else>
<!--                  <loader-appie/>-->
                  <div class="viewpostlist row" style="cursor: pointer">
                    <div v-for="(templateData,index) in viewlisttemplate" :key="index">
                      <!--                <div v-if="templateData.template_8 && templateData.template_8.length > 0">-->
                      <!--                  <div v-for="(item, itemIndex) in templateData.template_8" :key="itemIndex" style="text-align: center">-->

                      <!--                    <a @click="GetPlanimage(item.activity,item.url)">-->
                      <!--                      <img :src="item.src" alt="" style="min-width: -webkit-fill-available;">-->
                      <!--                    </a>-->

                      <!--                  </div>-->
                      <!--                </div>-->
                      <div v-if="templateData.template_9 && templateData.template_9.length > 0">
                        <div v-for="(item, itemIndex) in templateData.template_9" :key="itemIndex">

                          <div class="row  align-items-center">
                            <div class="col-lg-12">
                              <div class="appie-features-boxes whitebackground">
                                <a @click="postJob(item.activity,item.url)" style="display: block;">
                                  <div class="appie-features-box-item item-2  appie-features-box-5-item"
                                       :style="{borderColor:item.borderColor}">
                                    <img :src="item.image" alt="" class="imageSize">

                                    <span :style="{ color: item.txt_color,marginLeft:'20px' }">{{ item.title }}</span>
                                    <span class="badge"
                                          :style="{ color: item.btntextColor,float:'right',border:item.borderColor,backgroundColor:item.btnColor }"
                                          v-html="item.btnText"></span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div v-if="templateData.template_12 && templateData.template_12.length > 0">
                        <section class=" " id="">


                          <div class="col-12 col-md-12">
                            <div class="row">
                              <div class="col-12 col-md-4 col-lg-4 mb-20 temp_10_space"
                                   v-for="(item, itemIndex) in templateData.template_12" :key="itemIndex">
                                <a @click="ChangeRoute(item.activity,item.url)" style="display: block;">
                                  <div class="card" >
                                    <div class="card-body">

                                      <div class="row">
                                        <div class="col-8 col-md-8 col-lg-8">
                                          <h5 v-html="item.count"></h5>
                                          <p v-html="item.title !='' ? item.title : ''"></p>
                                        </div>
                                        <div class="col-4  col-md-4 col-lg-4">
                                          <img :src="item.icon" alt="" style="float: right;">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>

                            </div>
                          </div>



                        </section>
                      </div>

                      <br>
                      <div v-if="templateData.template_13 && templateData.template_13.length > 0" class="row">
                        <div v-for="(item, itemIndex) in templateData.template_13" :key="itemIndex" class="mt-2 col-12 col-md-4 col-lg-4">
                          <div class="card" style="width: 100%" >
                            <div class="card-body p-0">
                              <div style="display: flex;">
                                <!--                        <div class="row" style="display: flex;">-->
                                <a @click="OpenProfile(item.activity,item.url,item.action,item.type)"
                                   style="display: contents;">
                                  <div class="col-2">
                                    <img :src="item.image" style="height: 50px;">
                                  </div>
                                  <div class="col-8">
                                    <p :style="{fontSize:item.textSize,textAlign:item.gravity,color:black,padding:'10px'}">
                                      {{ stripTags(item.title) }}</p>
                                  </div>
                                  <div class="col-2" style="padding: 6px">
                                    <div v-if="item.btnVisible == '1'">
                                      <button type="button" class="btn"
                                              :style="{border:item.borderColor,backgroundColor:item.btnColor,color:item.btntextColor,}">
                                        {{ item.btnText }}
                                      </button>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
<!--            <br>-->

              <div class=" adrow row ">
                <div class="col-lg-12" >
                  <testimonial-login/>
                  <!--                    <pre>{{ mergedTemplates }}</pre>-->
                  <!--                  <div v-for="(templateData,index) in template" :key="index" >-->

                  <!--                    <div v-if="templateData.hasOwnProperty('template_11') && templateData.template_11.length > 0" class="templatedatelist">-->
                  <!--                      <div v-for="(item, itemIndex) in templateData.template_11" :key="itemIndex"-->
                  <!--                           style="text-align: center">-->
                  <!--                        <a @click="imageurl(item.url)">-->
                  <!--                          <img :src="item.src" alt="" style="">-->
                  <!--                        </a>-->
                  <!--                      </div>-->
                  <!--                    </div>-->

                  <!--                    <div v-if="templateData.hasOwnProperty('template_8') && templateData.template_8.length > 0"-->
                  <!--                         class="mt-2 templatedatelist graybackground p-2">-->
                  <!--                      <div v-for="(item, itemIndex) in templateData.template_8" :key="itemIndex" style="text-align: center">-->

                  <!--                        <a @click="GetPlanimage(item.activity,item.url)">-->
                  <!--                          <img :src="item.src" alt="" style="">-->
                  <!--                        </a>-->
                  <!--                      </div>-->
                  <!--                    </div>-->



                  <!--                  ---next update ----->
                  <!--                  <div v-if="templateData.template_10 && templateData.template_10.length > 0">-->
                  <!--                    <section class=" pt-20 pb-10" id="">-->
                  <!--                      <div class="row">-->
                  <!--                        <div class="col-6 col-md-3 temp_10_space" v-for="(item, itemIndex) in templateData.template_10" :key="itemIndex">-->

                  <!--                          <div >-->
                  <!--                            <button class="temp_10" :style="{ background : item.btnColor}">-->
                  <!--                              <a @click="OpenPage(item.activity,item.url)"  style="display: block;">-->
                  <!--                                <img  :src="item.icon" alt="" style="min-width: 50%">-->
                  <!--                              </a>-->
                  <!--                            </button>-->
                  <!--                          <h5 class="card-title text_space" :style="{ color:item.txt_color, textAlign:'center' }" >{{item.title}}</h5>-->
                  <!--                          </div>-->

                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </section>-->
                  <!--                  </div>-->

                  <!--                    <div v-if="templateData.hasOwnProperty('template_5')&& templateData.template_5.length > 0 " class="templatedatelist  ">-->

                  <!--                      <div v-for="(item, itemIndex) in templateData.template_5" :key="itemIndex" :class="{ 'col-md-6': item.name !== 'Visiting card' && item.name !== 'Give your feedback' && item.name !== 'Share app with your friends' }">-->
                  <!--                    <pre>{{ mergedTemplate5 }}</pre>-->


                  <!--                    </div>-->

                  <!--                  </div>-->

                </div>
              </div>

          </div>
          </div>
        </div>



      </div>


      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue" >
          <div class="row">

            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="stripTags(customerCareData.label)"></span>


              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>


    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import LoaderAppie from '../LoaderAppie.vue'
import CryptoJS from 'crypto-js';
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'

// import HeaderHomeTwo from './Header.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import Menubar from "@/components/HomePage/menu.vue";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";
// import VueSlickCarousel from 'vue-slick-carousel'
import TestimonialLogin from '@/components/LogIn/TestimonialLogin.vue'

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    TestimonialLogin,
    // VueSlickCarousel,
    Menubar,
    Commonprofile,
    // HeaderHomeTwo,
    LoaderAppie,
    // SidebarHomeOne,


  },
  data() {
    return {
      insideloader:false,
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 768,

          }
        ]
      },

      viewlisttemplate: '',
      canditatehistory:'',
      showloading:false,
      title: '',
      template: '',
      SideMenu: {},
      mergedTemplates:[],
      titleWord: '',
      customerCare: {},
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            {
              // name:'Home 5',
              name: 'Change Mobile Number',
              path: '/home-five'
            },


          ],
        },

        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },

        // {
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },


  async created() {
    // console.log('Entering created hook');
    if (this.$route.query.page) {
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const homeurlpost = this.decryptUrl(pageurl);
      // this.modifiedString = decryptedString;
      try {
        console.log('first',homeurlpost)
        const otpdata = await callAxiosWithConfig(homeurlpost, '', 'post');
        otpdata.template.forEach(item => {

          if (item.template_5 && Array.isArray(item.template_5)) {
            // Push each item of the template_5 array to the mergedTemplates array
            item.template_5.forEach(template => {
              if(template.name != 'Visiting card' && template.name != 'Give your feedback' && template.name != 'Share app with your friends'){
                this.mergedTemplates.push(template);
              }

            });
          }
          // Check if the item has a template_9 property and if it's an array
          if (item.template_9 && Array.isArray(item.template_9)) {
            // Push each item of the template_9 array to the mergedTemplates array
            item.template_9.forEach(template => {
              if(template.title != 'Employee View'){

                this.mergedTemplates.push(template);
              }

            });
          }

        });

        let triggertype="";
        let triggeraction="";
        let triggerurl='https://jobspro.nithrajobs.com/api/post/view/dashboard';
        let triggeractivity='nithra.jobs.career.jobslibrary.employer.activity.Employer_Dynamic_Home_Activity';
        this.commonview(triggeractivity,triggerurl,triggertype,triggeraction);

        this.title = otpdata.title;
        this.titleWord = otpdata.title;
        this.customerCare = otpdata.customerCare;
        let profileData = {
          name: otpdata.visitingcard?.name || "",
          company: otpdata.visitingcard?.company || ""
        };
        localStorage.setItem("SideMenu", JSON.stringify(otpdata.drawer))
        localStorage.setItem("titleWord", JSON.stringify(otpdata.title))
        localStorage.setItem("customerCare", JSON.stringify(otpdata.customerCare))
        localStorage.setItem("profileData", JSON.stringify(profileData))
        // console.log(typeof(this.customerCare))
        this.template = otpdata.template;
        this.SideMenu = otpdata.drawer;
        this.showloading=false;
        // console.log(this.SideMenu)
        // const inputString = otpdata;
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);


      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
      // alert(this.modifiedString);
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');


    }
    else {
      // console.log('homepagelink')
      this.showloading=true;
      const homepageurl = localStorage.getItem("homeurl")
      try {
        // console.log('second',homepageurl)
        const otpdata = await callAxiosWithConfig(homepageurl, '', 'post');
          otpdata.template.forEach(item => {

          if (item.template_5 && Array.isArray(item.template_5)) {
            // Push each item of the template_5 array to the mergedTemplates array
            item.template_5.forEach(template => {
              if(template.name != 'Visiting card' && template.name != 'Give your feedback' && template.name != 'Share app with your friends'){
              this.mergedTemplates.push(template);
            }

            });
          }
          // Check if the item has a template_9 property and if it's an array
          if (item.template_9 && Array.isArray(item.template_9)) {
            // Push each item of the template_9 array to the mergedTemplates array
            item.template_9.forEach(template => {
              if(template.title != 'Employee View'){

                this.mergedTemplates.push(template);
              }

            });
          }

        });


        //
        // otpdata.template.forEach(item => {
        //
        //   if (Array.isArray(item.template_5)) {
        //     this.mergedTemplate5.push(...item.template_5);
        //   }
        //
        // });



        this.title = otpdata.title;
        this.titleWord = otpdata.title;
        this.customerCare = otpdata.customerCare;
        let triggertype="";
        let triggeraction="";
        let triggerurl='https://jobspro.nithrajobs.com/api/post/view/dashboard';
        let triggeractivity='nithra.jobs.career.jobslibrary.employer.activity.Employer_Dynamic_Home_Activity';
        this.commonview(triggeractivity,triggerurl,triggertype,triggeraction);
        let profileData = {
          name: otpdata.visitingcard?.name || "",
          company: otpdata.visitingcard?.company || ""
        };
        localStorage.setItem("SideMenu", JSON.stringify(otpdata.drawer))
        localStorage.setItem("titleWord", JSON.stringify(otpdata.title))
        localStorage.setItem("customerCare", JSON.stringify(otpdata.customerCare))
        localStorage.setItem("profileData", JSON.stringify(profileData))
        // console.log(typeof(this.customerCare))
        this.template = otpdata.template;
        this.SideMenu = otpdata.drawer;
        this.showloading=false;
         // this.mergedTemplate5 = otpdata.template.flatMap(item => item.template_5);

        // console.log(this.SideMenu)
        // const inputString = otpdata;
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
    }



  },

  methods: {
    async ChangeRoute(activity, url) {
      // const encryptedString = this.encryptUrl(url);
// alert(activity)
// alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;


      if (lastPart === 'Employer_Common_Webview_Activity') {
        // window.location.href = this.urlData
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        window.open(this.urlData, '_blank');

      } else if (lastPart == 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Dynamic_Job_List') {
        const desiredPath = url.split('/').pop();
        // alert(desiredPath);
        if (desiredPath == 'paymentHistory') {
          // alert('s')
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/payment-history?page=${encodeURIComponent(encryptedString)}`);
        } else {
          // alert('mo')
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/waiting-post?page=${encodeURIComponent(encryptedString)}`);
        }


      }
    },
    async OpenProfile(activity, url, action, type) {

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }
      else if (lastPart === '') {
        if (action == 'url') {
          // alert(type)
          window.location.href = type
        }
      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }
    },

    async canditatehist(url){
       const candlist = url;
        try {
          const canditateHistoryData = await callAxiosWithConfig(candlist, '', 'post');
          this.canditatehistory = canditateHistoryData.template;
          this.list = canditateHistoryData.list;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            // Handle 401 status silently
            // For example, do nothing or log a message without displaying it
          } else {
            // Handle other errors by displaying them
            console.error('Error in Axios request:', error);
          }

        }

    },

async viewpost(url){

     this.insideloader=true;
 const viewpostdetails = url;
     try {
       const ViewPostData = await callAxiosWithConfig(viewpostdetails, '', 'post');
       // console.log(ViewPostData)
       this.insideloader=false;

       this.viewlisttemplate = ViewPostData.template;

     } catch (error) {
       if (error.response && error.response.status === 401) {
         // Handle 401 status silently
         // For example, do nothing or log a message without displaying it
       } else {
         // Handle other errors by displaying them
         if (error.response && error.response.status === 401) {
           // Handle 401 status silently
           // For example, do nothing or log a message without displaying it
         } else {
           // Handle other errors by displaying them
           console.error('Error in Axios request:', error);
         }
       }

     }


 },


    shouldHaveGrid(name) {
      return name !== 'Visiting card' && name !== 'Give your feedback' && name !== 'Share app with your friends';
    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },
    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },


    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },


    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    async Click_template5(activity, url) {

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        this.canditatehist(url);
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/candidate-profile?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Common_Webview_Activity') {


        // window.location.href = this.urlData;
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
      }
    },
    async imageurl(url) {
      // alert(activity)
      // const encryptedString = this.encryptUrl(url);
      window.location.href = url;
    },

    async GetPlanimage(activity, url) {
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;
      if (lastPart === 'Employer_Common_Webview_Activity') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        // window.location.href = this.urlData
      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
    async commonview(activity, url,type,action) {

      // const encryptedString = this.encryptUrl(url);
      // await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'Employer_Dynamic_Home_Activity') {

        this.viewpost(url);

        // alert('jjdjfjfj')
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);


      } else if (lastPart === 'Employer_Company_Register') {


        if(url=='https://jobspro.nithrajobs.com/api/upload/Form/Fields'){
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/kyc-register?page=${encodeURIComponent(encryptedString)}`);
        }
        else{
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
        }
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }
      else if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }
      else if (lastPart === 'Employer_Common_Webview_Activity') {


        // alert('dfasdf')
        // window.location.href = this.urlData;
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
      }
      else if (action == 'url') {

          // alert(type)
          window.location.href = type

      }

    },
    // async doubt(activity, url) {
    //
    //   // const encryptedString = this.encryptUrl(url);
    //   // await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);
    //
    //   const inputString = activity;
    //   const lastPart = inputString.split('.').pop();
    //   this.urlData = url;
    //
    //   if (lastPart === 'Employer_Dynamic_Home_Activity') {
    //
    //     this.viewpost(url);
    //     // alert('jjdjfjfj')
    //     // const encryptedString = this.encryptUrl(url);
    //     // await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);
    //
    //
    //   } else if (lastPart === 'Employer_Company_Register') {
    //     const encryptedString = this.encryptUrl(url);
    //     await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
    //   }
    //   else if (lastPart === 'ViewCandidate_List') {
    //     const encryptedString = this.encryptUrl(url);
    //     await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
    //   }
    //
    // },
    async postJob(activity, url) {
      // alert(activity)
      // alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        try {
          const ViewPostData = await callAxiosWithConfig(this.urlData, '', 'post');
          // console.log(otpdatViewPostData);
          // console.log(ViewPostData);
          this.ViewPosttitle = ViewPostData.title;
          // this.template = otpdata.template;
          // console.log(this.template)
          // const inputString = otpdata;
        } catch (error) {
          console.error('Error in Axios request:', error);
        }
      } else if (lastPart === 'Employer_Common_Webview_Activity') {


        // window.location.href = this.urlData
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        window.open(this.urlData, '_blank');

      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

    }
  }

}
</script>

<style>
.maincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;
  width: 100%;
  background: white;
}

.imageSize {
  width: 10% !important;
}

@media (min-width: 768px) {
  .maincard {
    width: 90% !important;
  }
  .temptcard{
    width: 95%;
    margin: auto;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
    padding: 20px 10px 10px 10px;
    background: white;
  }
}

.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10% !important;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}


/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }


}

.fa-phone.flipped {
  /* Set the font size to make the icon bigger */
  font-size: 24px; /* Adjust the size as needed */

  /* Set a big border */
  border: 4px solid red; /* Adjust the border size and color as needed */
  border-radius: 50%; /* Make the border circular */
  padding: 8px; /* Adjust the padding as needed */
}

.fa-phone {
  /* Set the font size to make the icon larger */
  font-size: 24px; /* Adjust the size as needed */
}

.flipped {
  transform: scaleX(-1); /* Flip the icon horizontally */
}

.appie-features-box-item {
  padding: 2px !important;
}
.templatedatelist{
  width: 95%;
  margin: auto;
}
.homelist{
  //height: 80px;
  border: 1px solid #707070 !important;
  border-radius: 15px;
 background-color: rgb(255, 255, 255)
}

</style>

